import RemoveAccents from 'remove-accents';

export const cleanFileName = (fileName: string): string =>
  encodeURI(
    RemoveAccents.remove(fileName)
      .replace(/[\s,_%‰#°€$§&.()+?:–\\/]/g, '-')
      .replace(/--/g, '-')
      .toLowerCase()
  );
